export const infoWidth = 160;
export const boxWidth = 195;
export const physWidth = 210;
